export const useGetStoreLink = (deeplink?: string) => {
  if (deeplink) {
    deeplink = encodeURIComponent(deeplink);
  }
  deeplink = deeplink || "";
  const route = useRoute();
  const query = route.query;

  if (query["referrerId"]) {
    // 초대용 링크
    const referrerId = query["referrerId"] as string;
    const referrerOnelink = useRuntimeConfig().public.REFERRER_ONELINK;
    return `${referrerOnelink}?af_force_deeplink=true&af_dp=${deeplink}&deep_link_sub1=${referrerId}`
  } else if (decodeURIComponent(route.path).includes("referrerId=")) {
    // 초대용 링크(인코딩 되어있을때)
    const params = new URLSearchParams(
      decodeURIComponent(route.path).split("?")[1]
    );
    const referrerId = params.get("referrerId") as string;
    const referrerOnelink = useRuntimeConfig().public.REFERRER_ONELINK;
    const link = referrerId
      ? `${referrerOnelink}?af_force_deeplink=true&deep_link_sub1=${referrerId}`
      : `${referrerOnelink}?af_force_deeplink=true`
    return link;
  } else {
    const onelink_template_id =
      (route.query.onelink_template_id as string) || "anCR";
    const onelink_url_id = (route.query.onelink_url_id as string) || "";
    let link = `https://oivivalavida.onelink.me/OHzl/azdc2gq9?af_force_deeplink=true&af_dp=${deeplink}`;
    if (route.query.utm_source === "meta") {
      link = `https://oivivalavida.onelink.me/OHzl/r3ry36j3?af_force_deeplink=true&af_dp=${deeplink}`;
    } else if (route.query.utm_source === "google-ads") {
      link = `https://oivivalavida.onelink.me/6FsO/1oqv8pjt?af_force_deeplink=true&af_dp=${deeplink}`;
    } else if (onelink_url_id) {
      link = `https://oivivalavida.onelink.me/${onelink_template_id}/${onelink_url_id}?af_force_deeplink=true&af_dp=${deeplink}`;
    }
    return link;
  }
};
